import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { NewPasswordFormState } from '../../Components/Forms/NewPasswordForm';
import { REQUEST_ACTIONS } from '../../Constants/Actions.constants';
import { Route } from '../../Constants/Routes.constants';
import { useLanguage } from '../../Hooks/useLanguage';
import { useQuery } from '../../Hooks/useQuery';
import { selectLoading } from '../../store/app';
import { selectPasswordRecovery, requestNewPassword, NewPasswordAction } from '../../store/auth';
import RecoverPasswordNewPassword from './RecoverPasswordNewPassword.component';

// eslint-disable-next-line max-len
export const submitNewPassword = (resetToken: string) => (newPasswordAction: NewPasswordAction) => (
  data: NewPasswordFormState,
) => newPasswordAction({ password: { ...data, reset_password_token: resetToken } });

export const useRecoverPasswordNewPassword = () => {
  const dispatch = useDispatch();
  const query = useQuery();
  const newPasswordRequestSuccess = useSelector(
    selectPasswordRecovery(REQUEST_ACTIONS.NEW_PASSWORD),
  );
  const isSetNewPasswordLoading = useSelector(selectLoading(REQUEST_ACTIONS.NEW_PASSWORD));
  const newPasswordAction = bindActionCreators(requestNewPassword, dispatch);
  const { t } = useLanguage();

  const token = query.get('reset_password_token');
  const handleSubmitNewPasswordAction = submitNewPassword(token || '');

  return {
    t,
    token,
    onNewPasswordFormSubmit: handleSubmitNewPasswordAction(newPasswordAction),
    isSetNewPasswordLoading,
    newPasswordRequestSuccess,
  };
};

const RecoverPassswordNewPasswordContainer = () => {
  const {
    t,
    onNewPasswordFormSubmit,
    token,
    newPasswordRequestSuccess,
    isSetNewPasswordLoading,
  } = useRecoverPasswordNewPassword();
  return (
    <>
      {!token && <Redirect to={Route.LOGIN} />}
      {newPasswordRequestSuccess && <Redirect to={Route.NEW_PASSWORD_SUCCESS} />}
      <RecoverPasswordNewPassword
        onNewPasswordSubmit={onNewPasswordFormSubmit}
        passwordResetLoading={isSetNewPasswordLoading}
        t={t}
      />
    </>
  );
};

export default RecoverPassswordNewPasswordContainer;
